import { Component, forwardRef, Input, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import _ from 'lodash';
import { observeObject } from '@internal/common-ui/common';

export interface IFilterOption {
  label?: string;
  icon?: string;
}

export const FilterList_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FilterListComponent),
  multi: true
}


@Component({
  selector: 'filter-list',
  templateUrl: './filter-list.component.html',
  styleUrls: ['./filter-list.component.scss'],
  providers: [FilterList_VALUE_ACCESSOR],
})
export class FilterListComponent implements ControlValueAccessor {
  _options: IFilterOption[] = [];
  @Input()
  get options(): IFilterOption[] {
    return this._options;
  }
  set options(val: IFilterOption[]) {
    this._options = val;
    this.refreshTemplateList();
  }

  @Input() style: any;

  @Input() customFilter: TemplateRef<any>;

  @Input() itemSize: number;

  @Input() itemTemplate: TemplateRef<any>;

  _listStyle: any;
  @Input()
  get listStyle() {
    return this._listStyle;
  }
  set listStyle(val: any) {
    this._listStyle = val || {};
    if (this._listStyle == null || !('height' in this._listStyle)) {
      if ('min-height' in this._listStyle) {
        this._listStyle['height'] = this._listStyle['min-height'];
      } else if ('max-height' in this._listStyle) {
        this._listStyle['height'] = this._listStyle['max-height'];
      } else {
        this._listStyle['height'] = '150px';
      }
    }
  }

  disabled: boolean;
  value: IFilterOption;
  onChanged: (val: IFilterOption) => void;
  onTouched: Function;

  // these three properties are observed by observeObject function
  // any changes will trigger view to refresh
  keyWord: string;

  constructor(
    private cd: ChangeDetectorRef,
  ) {
    observeObject(this,
      ['keyWord',],
      _.debounce(this.refreshTemplateList.bind(this), 100)
    );
  }


  optionsDisplay: IFilterOption[] = [];

  refreshTemplateList() {
    this.optionsDisplay = this.options
      .filter(it => this.filterByKeyWord(it));
    this.cd.markForCheck();
  }

  filterByKeyWord(template: IFilterOption) {
    return !this.keyWord?.length || template.label?.toLocaleLowerCase()?.indexOf(this.keyWord.toLocaleLowerCase()) >= 0;
  }



  onClick(template: IFilterOption) {
    this.writeValue(template);
    this.onChanged?.(this.value);
  }






  writeValue(obj: any): void {
    this.value = obj;
    this.cd.markForCheck();
  }
  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.cd.markForCheck();
  }

}